import { DEFAULT_CACHE_TIME, DEFAULT_STALE_TIME } from '@web/constants';

export const CONVERSATION_CACHE_TIME = DEFAULT_CACHE_TIME;
export const CONVERSATION_MESSAGES_CACHE_TIME = DEFAULT_CACHE_TIME;

export const CONVERSATION_STALE_TIME = DEFAULT_STALE_TIME;
export const CONVERSATION_MESSAGES_STALE_TIME = DEFAULT_STALE_TIME;
